import { render } from "./serviceTeaser.vue?vue&type=template&id=67beaaca"
import script from "./serviceTeaser.vue?vue&type=script&lang=js"
export * from "./serviceTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__